import {getMuseumIdFromCollectionId} from "../utility";
import {clientLog} from "../clientLog";
import {getSystemTags} from "./getSystemTags";
import {tagsSearchHandler} from "./tagsSearchHandler";

export const publishingTagsInDb = async (collectionId, museums, museumCollections, errorCallback) => {
    if (!collectionId) {
        throw new Error('Collection ID is required to fetch tags.');
    }
    if (!museums || museums.length === 0) {
        throw new Error('Museums are required to fetch tags.');
    }
    if (!museumCollections || museumCollections.length === 0) {
        throw new Error('Museum collections are required to fetch tags.');
    }

    const getTagTypes = async () => {
        const tagPrefix = 'publishing-'
        const systemTags = await getSystemTags();
        return systemTags.map(st => (`${tagPrefix}${st['publishingType']}`));
    };

    const museumId = getMuseumIdFromCollectionId({
        museums: museums,
        museumCollections: museumCollections,
        collectionId: collectionId
    });

    if (!museumId) {
        clientLog('error',
            'no museum found for collection id: ' + collectionId,
            'publishingtagsindb');
        errorCallback();
    } else {
        try {
            return (async () => {
                const tagTypes = await getTagTypes();
                return await tagsSearchHandler([museumId], '*', tagTypes);
            })();
        } catch (error) {
            clientLog('error',
                'error fetching publishing tags from DB: ' + error.toString(),
                'publishingtagsindb');
            errorCallback(error);
            return [];
        }
    }
};